import { StarValue } from '@suntex.fim/hub';

export interface ProgressStarProps {
  star: StarValue;
  size?: number;
  className?: string;
}

const STAR_PATH =
  'M12 2l2.9 6.26L22 9.27l-5.46 5.01 1.29 7.22L12 18l-5.83 3.5 1.29-7.22L2 9.27l7.1-1.01L12 2z';

const COLORS: Record<StarValue, { fill: string; stroke: string } | null> = {
  [StarValue.None]: null,
  [StarValue.Silver]: { fill: '#c0c0c0', stroke: '#a8a8a8' },
  [StarValue.Gold]: { fill: '#fbbf24', stroke: '#d97706' },
};

/**
 * A silver or gold star icon for displaying module progress.
 * Renders nothing when star is StarValue.None.
 */
export function ProgressStar({
  star,
  size = 18,
  className,
}: ProgressStarProps) {
  const colors = COLORS[star];
  if (!colors) return null;

  const label = star === StarValue.Gold ? 'Gold star' : 'Silver star';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-label={label}
      role="img"
      className={className}
      style={{ flexShrink: 0 }}
    >
      <path
        d={STAR_PATH}
        fill={colors.fill}
        stroke={colors.stroke}
        strokeWidth="1"
      />
    </svg>
  );
}
